"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMediaKind = void 0;
const enum_1 = require("../../../../utils/enum");
exports.EMediaKind = (0, enum_1.strEnum)(["IMAGE", "VIDEO", "URL"]);
